const trackingUtils = require('od-modules/utils/tracking.utils');
const btnGroupClass = 'custom_control_btn_group';
const btnClass = 'custom_control_btn';
const activeClass = 'active';
const BUTTON_GROUP_OPTIONS = {
    groupCssClass: 'od-map-btn-group odf-btn-group',
    itemCssClass: 'odf-btn odf-btn-sm odf-btn-switcher',
};
const BUTTON_GROUP_STYLES = [{
    text: Odigeo.UIElements.translations.dynpackProduct.mapButtonControls.showPrice,
    data: {
        showPrices: true,
    },
    active: true,
}, {
    text: Odigeo.UIElements.translations.dynpackProduct.mapButtonControls.hidePrice,
    data: {
        showPrices: false,
    },
    active: false,
}];

const MapControlBtnGroup = function(map, libMap, args) {
    this.libMap = libMap;
    this.setOptions(args || {});
    this.createElement(args || {});
    this.setMap(map);
};

MapControlBtnGroup.prototype.setOptions = function(options) {
    this.opts = Odigeo._.extend({
        position: this.libMap.ControlPosition.TOP_LEFT,
    }, BUTTON_GROUP_OPTIONS, options);
};

MapControlBtnGroup.prototype.setMap = function(map) {
    map.controls[this.opts.position].push(this.getElement());
};

MapControlBtnGroup.prototype.createElement = function(options) {
    this.$el = $('<div>', {
        'class': btnGroupClass + ' ' + this.opts.groupCssClass,
    });

    this.$el.append(this.getNewButtons(Odigeo._.extend(BUTTON_GROUP_STYLES, options.style)));
};

MapControlBtnGroup.prototype.getNewButtons = function(options) {
    return Odigeo._.map(options, this.createButton, this);
};

MapControlBtnGroup.prototype.createButton = function(btnConfig) {
    const $btn = $('<div></div>', {
        'class': btnClass + ' ' + this.opts.itemCssClass,
        'text': btnConfig.text,
    });

    $btn.toggleClass(activeClass, btnConfig.active).data(btnConfig.data);
    this.bindEvent($btn);

    return $btn;
};

MapControlBtnGroup.prototype.bindEvent = function($btn) {
    this.libMap.event.addDomListener($btn.get(0), 'click', Odigeo._.bind(function(e) {
        const $el = $(e.target);

        this.libMap.event.trigger(this, 'launch', $el.data());
        this.trackingBtn($el);
        this.activateBtn($el);
    }, this));
};

MapControlBtnGroup.prototype.getElement = function() {
    return this.$el.get(0);
};

MapControlBtnGroup.prototype.activateBtn = function($btn) {
    return $btn.addClass(activeClass).siblings().removeClass(activeClass);
};

MapControlBtnGroup.prototype.trackingBtn = function($btn) {
    if (!$btn.hasClass((activeClass))) {
        const labelAction = $btn.data('showPrices') ? 'show' : 'hide';

        trackingUtils.trackEvent('results_list_hotels_map', 'map_prices_' + labelAction);
    }
};

module.exports = MapControlBtnGroup;
